export default __webpack_public_path__ + "static/media/logout-bg-img.6f4cb105.png";